/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Sub_Cancel_BodyInputs */



/**
* | output |
* | --- |
* | "Cancellation takes effect at the end of the current billing period. You can re-subscribe later." |
*
* @param {Gateway_Sub_Cancel_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_cancel_body = /** @type {((inputs?: Gateway_Sub_Cancel_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Cancel_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Kündigung wird zum Ende der aktuellen Abrechnungsperiode wirksam. Sie können sich später erneut anmelden.")
	return /** @type {LocalizedString} */ ("Cancellation takes effect at the end of the current billing period. You can re-subscribe later.")
});